import { useFadeIn } from '../../../hooks/useFadeIn';
import { useLang } from '../../../context/LanguageContext';

const services = [
  {
    icon: 'ri-alarm-warning-line',
    titleRo: 'Sisteme de Alarmă',
    titleRu: 'Системы Сигнализации',
    descRo: 'Instalare și configurare profesională Ajax, Paradox și Bosch. Protecție 24/7 cu notificări instant pe telefon.',
    descRu: 'Профессиональная установка Ajax, Paradox и Bosch. Защита 24/7 с мгновенными уведомлениями.',
    image: 'https://public.readdy.ai/ai/img_res/e5a897bdc7175e95707a4da7a91096e1.jpg',
    features: [
      { ro: 'Ajax / Paradox / Bosch', ru: 'Ajax / Paradox / Bosch' },
      { ro: 'GSM + WiFi', ru: 'GSM + WiFi' },
      { ro: 'Control din App', ru: 'Управление с App' },
      { ro: 'Monitorizare 24h', ru: 'Мониторинг 24ч' },
    ],
  },
  {
    icon: 'ri-camera-line',
    titleRo: 'Supraveghere Video',
    titleRu: 'Видеонаблюдение',
    descRo: 'Camere CCTV Hikvision și Dahua 4K, vizibilitate nocturnă, stocare cloud. Live de oriunde în lume.',
    descRu: 'Камеры Hikvision и Dahua 4K, ночное видение, облако. Просмотр в реальном времени.',
    image: 'https://readdy.ai/api/search-image?query=Hikvision%20CCTV%20security%20camera%20dome%20mounted%20on%20wall%2C%204K%20professional%20surveillance%20camera%2C%20dark%20modern%20background%2C%20cinematic%20lighting%2C%20high%20tech%20security%20equipment%2C%20dark%20charcoal%20background&width=600&height=400&seq=svc002&orientation=landscape',
    features: [
      { ro: 'Hikvision / Dahua 4K', ru: 'Hikvision / Dahua 4K' },
      { ro: 'Night Vision IR', ru: 'ИК ночное видение' },
      { ro: 'Cloud Storage', ru: 'Облачное хранилище' },
      { ro: 'Live Remote View', ru: 'Просмотр онлайн' },
    ],
  },
  {
    icon: 'ri-door-lock-line',
    titleRo: 'Interfoane & Control Acces',
    titleRu: 'Домофоны и Контроль доступа',
    descRo: 'Sisteme video smart, cititori de card și amprentă, control acces de la distanță prin smartphone.',
    descRu: 'Умные видеодомофоны, считыватели карт и отпечатков, удалённый контроль доступа.',
    image: 'https://readdy.ai/api/search-image?query=modern%20smart%20video%20intercom%20system%20on%20dark%20wall%2C%20touchscreen%20access%20control%20panel%2C%20fingerprint%20reader%2C%20high%20tech%20security%20door%20system%2C%20professional%20security%20equipment%2C%20dark%20charcoal%20background%2C%20sleek%20design&width=600&height=400&seq=svc003&orientation=landscape',
    features: [
      { ro: 'Video HD', ru: 'Видео HD' },
      { ro: 'Card / Amprentă', ru: 'Карта / Отпечаток' },
      { ro: 'App Unlock', ru: 'Открытие с App' },
      { ro: 'Multi-apartament', ru: 'Многоквартирный' },
    ],
  },
  {
    icon: 'ri-home-wifi-line',
    titleRo: 'Smart Home Security',
    titleRu: 'Умный дом — Безопасность',
    descRo: 'Integrare completă cu smart home: lumini, prize, senzori de fum și inundație controlate din app.',
    descRu: 'Полная интеграция с умным домом: освещение, датчики дыма и затопления.',
    image: 'https://readdy.ai/api/search-image?query=smart%20home%20security%20hub%20touchpad%20control%20panel%20with%20glowing%20display%2C%20modern%20interior%20dark%20background%2C%20connected%20devices%20IoT%2C%20green%20LED%20indicators%2C%20technology%20lifestyle%2C%20cinematic%20dark%20room&width=600&height=400&seq=svc004&orientation=landscape',
    features: [
      { ro: 'Home Automation', ru: 'Автоматизация' },
      { ro: 'Senzori Fum/Gaz', ru: 'Датчики дыма/газа' },
      { ro: 'Flood Detection', ru: 'Защита от затопления' },
      { ro: 'Voice Control', ru: 'Голосовое управление' },
    ],
  },
  {
    icon: 'ri-fire-line',
    titleRo: 'Detectare Incendiu',
    titleRu: 'Пожарная Сигнализация',
    descRo: 'Detecție timpurie a fumului și temperaturii. Alertare automată a pompierilor și proprietarilor.',
    descRu: 'Раннее обнаружение дыма и температуры. Автоматическое оповещение.',
    image: 'https://readdy.ai/api/search-image?query=fire%20detection%20smoke%20alarm%20sensor%20device%20mounted%20on%20ceiling%2C%20modern%20white%20detector%20on%20dark%20background%2C%20professional%20fire%20safety%20equipment%2C%20high%20tech%20sensor%2C%20green%20LED%20light%2C%20clean%20product%20photo&width=600&height=400&seq=svc005&orientation=landscape',
    features: [
      { ro: 'Detecție Fum', ru: 'Датчик дыма' },
      { ro: 'Senzori Termici', ru: 'Тепловые датчики' },
      { ro: 'Alertă Auto 112', ru: 'Оповещение 112' },
      { ro: 'Certificat EN', ru: 'Сертификат EN' },
    ],
  },
  {
    icon: 'ri-tools-line',
    titleRo: 'Mentenanță & Suport',
    titleRu: 'Обслуживание и Поддержка',
    descRo: 'Contracte anuale, intervenție în 2h, actualizări software și înlocuire piese sub garanție.',
    descRu: 'Годовые контракты, выезд за 2 часа, обновления ПО и замена деталей по гарантии.',
    image: 'https://readdy.ai/api/search-image?query=security%20technician%20installing%20professional%20surveillance%20camera%20system%2C%20dark%20modern%20setting%2C%20tools%20and%20equipment%2C%20high%20tech%20service%2C%20professional%20uniform%2C%20cinematic%20dramatic%20lighting%2C%20charcoal%20background&width=600&height=400&seq=svc006&orientation=landscape',
    features: [
      { ro: 'Garanție 3 ani', ru: 'Гарантия 3 года' },
      { ro: 'Intervenție 2h', ru: 'Выезд за 2 часа' },
      { ro: 'Update Software', ru: 'Обновление ПО' },
      { ro: 'Piese Originale', ru: 'Оригинальные детали' },
    ],
  },
];

export default function Services() {
  const ref = useFadeIn<HTMLElement>();
  const { t } = useLang();

  return (
    <section id="services" ref={ref} className="section-fade py-24 bg-charcoal relative">
      <div className="absolute inset-0 cyber-grid-bg opacity-30"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="slide-in-left inline-block px-4 py-1 rounded-full border border-neon/30 bg-neon/5 text-neon text-xs font-inter tracking-widest uppercase mb-4">
            {t('Servicii', 'Услуги')}
          </span>
          <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-white">
            {t('Soluții Complete de Securitate', 'Комплексные решения безопасности')}
          </h2>
          <p className="font-inter text-cyber-muted mt-3 text-base max-w-xl mx-auto">
            {t(
              'Instalăm, configurăm și oferim suport pentru toate tipurile de sisteme de securitate.',
              'Устанавливаем, настраиваем и поддерживаем все типы систем безопасности.'
            )}
          </p>
          <div className="mt-5 mx-auto w-16 h-0.5 bg-neon rounded-full line-grow"></div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, idx) => (
            <div
              key={service.titleRo}
              className="group stagger-item relative rounded-lg border bg-charcoal-100 overflow-hidden transition-all duration-400 card-hover-glow cursor-default"
              style={{
                borderColor: 'rgba(0,255,136,0.12)',
              }}
            >
              {/* Image */}
              <div className="w-full h-40 overflow-hidden relative">
                <img
                  src={service.image}
                  alt={service.titleRo}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-charcoal-100"></div>
                {/* Icon badge */}
                <div className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-md bg-charcoal/80 border border-neon/30 backdrop-blur-sm">
                  <i className={`${service.icon} text-lg text-neon`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="font-rajdhani font-bold text-lg text-white leading-tight mb-2">
                  {t(service.titleRo, service.titleRu)}
                </h3>
                <p className="font-inter text-sm text-cyber-muted mb-4 leading-relaxed">
                  {t(service.descRo, service.descRu)}
                </p>
                {/* Features */}
                <div className="grid grid-cols-2 gap-1.5">
                  {service.features.map((f) => (
                    <div key={f.ro} className="flex items-center gap-1.5">
                      <span className="w-1.5 h-1.5 rounded-full bg-neon flex-shrink-0"></span>
                      <span className="font-inter text-xs text-cyber-text">{t(f.ro, f.ru)}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Glow on hover */}
              <div className="absolute inset-0 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{ boxShadow: 'inset 0 0 30px rgba(0,255,136,0.04)' }}></div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://wa.me/37360123456?text=Buna%20ziua!%20Doresc%20un%20deviz%20gratuit%20pentru%20servicii."
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2.5 px-7 sm:px-8 py-3.5 sm:py-4 rounded-md bg-neon text-charcoal font-rajdhani font-bold text-sm sm:text-base md:text-lg btn-neon transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
            {t('Cere Deviz Gratuit — WhatsApp', 'Запросить смету — WhatsApp')}
          </a>
        </div>
      </div>
    </section>
  );
}
